import { Component } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

@Component({
    selector: 'app-branding-bar',
    templateUrl: './branding-bar.component.html',
    styleUrl: './branding-bar.component.scss',
    imports: [MatIconModule],
})
export class BrandingBarComponent {}
